import React, { useCallback, useEffect, useState } from "react";
import { Link } from "yarrr";
import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

import Grid from "../../../../Components/Grid";
import Spacer from "../../../../Components/Spacer";
import { getKnowledgeProjects } from "../../../../Api/services/ai";
import { useNavigation } from "../../../../Hooks/useNavigation";
import { createKnowledgeProject } from "../../../../Api/services/ai";
import Table from "../../../../Components/TableLite/TableLite";
import Button from "../../../../Components/Button";

const COLUMNS = [
	{
		id: "name",
		label: "Name",
		isSortable: false,
		getter: (row) => {
			return <Link href={`/ai/knowledge-project/${row._id}`}>{row.name}</Link>;
		},
	},
	{
		id: "updatedAt",
		label: "Updated At",
		isSortable: false,
		getter: (row) => format(row.updatedAt, "MM/dd/yyyy hh:mm a"),
	},
];

export const RagView = () => {
	const navigate = useNavigation();
	const { data } = useQuery({
		queryKey: ["knowledge-projects"],
		queryFn: () => getKnowledgeProjects(),
	});

	const rows = data || [];

	const handleClick = async () => {
		const { projectId } = await createKnowledgeProject({ name: "New Project" });
		navigate.navigate(`/ai/knowledge-project/${projectId}`);
	};

	return (
		<div>
			<Grid columns={["1fr", "200px"]}>
				<div />
				<Button onClick={handleClick}>Create RAG</Button>
			</Grid>
			<Spacer size={3} />
			<Table columns={COLUMNS} rows={rows} />
		</div>
	);
};
